import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { map, Observable } from 'rxjs';
import { InputOption } from 'app/shared/components';
import { PortalConfigurationDto } from './portal-configuration.dto';
import { PortalOrganisationDto } from './portal-organisation.dto';
import { PortalOrganisation } from 'app/domain/organisations/portal-organisation.model';
import { toPortalOrganisation } from './organisation.mapper';

const PORTAL_URL = `${environment.apiURL}/customerdata/portal`;

@Injectable({ providedIn: 'root' })
export class OrganisationApiService {
  private readonly http = inject(HttpClient);

  getConfigurations(): Observable<InputOption[]> {
    return this.http
      .get<PortalConfigurationDto[]>(`${PORTAL_URL}/configurations`)
      .pipe(map((dtos) => dtos.map(({ configId }) => ({ value: configId, label: configId }))));
  }

  getOrganisations(): Observable<PortalOrganisation[]> {
    return this.http
      .get<PortalOrganisationDto[]>(`${PORTAL_URL}/organisations`)
      .pipe(map((dtos) => dtos.map(toPortalOrganisation)));
  }
}
